export default {
  methods: {
    estimatedTrafficPerToken(plan, percent = 100) {
      return plan?.avg_bid ? Math.round(100 / (plan.avg_bid * (percent/100))) : null;
    }
  }
}
